import { OK, CREATED, UNPROCESSABLE_ENTITY, getCookieValue, setCookie, getDateAgo } from '../util'
import store from "./index";

const state = {
    user: null,
    apiStatus: null,
    loginErrorMessages: null,
    registerErrorMessages: null,
    token: null,
    tokenLimitDay: 365*2,
    tempRegisterStatus: null,
}

const getters = {
    check: state => !! state.user,
    username: state => state.user ? state.user.name : '',
    token: state => getCookieValue('token')
}

const mutations = {
    setUser (state, user) {
        state.user = user
    },
    setApiStatus (state, status) {
        state.apiStatus = status
    },
    setLoginErrorMessages (state, messages) {
        state.loginErrorMessages = messages
    },
    setRegisterErrorMessages (state, messages) {
        state.registerErrorMessages = messages
    },
    setToken (state, token) {
        setCookie('token', token, state.tokenLimitDay)
        state.token = token
    },
    setTempRegisterStatus (state, status) {
        state.tempRegisterStatus = status
    },
}

const actions = {
    // 退会処理
    async leave(context, data) {
        const resLeave = await axios.post('/api/leave', data)

        if (resLeave.status === OK) {
            await axios.post('/api/logout')
            location.href='/login';
            return false
        }
    },
    // 招待からの本登録処理
    async completeInviteRegister (context, data) {
        const response = await axios.post('/api/invite/complete_register', data)

        if (response.status === OK) {
            context.commit('setApiStatus', true)
            context.commit('setUser', response.data)
            context.commit('setToken', response.data.token)
            return false
        }

        if (response.status === UNPROCESSABLE_ENTITY) {
            context.commit('setRegisterErrorMessages', response.data.errors)
        } else {
            context.commit('error/setCode', response.status, { root: true })
        }
    },
    // 本登録処理
    async completeRegister (context, token) {
        context.commit('setApiStatus', null)
        const response = await axios.post('/api/complete_register', {token: token})

        if (response.status === CREATED) {
            context.commit('setApiStatus', true)
            context.commit('setUser', response.data)
            context.commit('setToken', response.data.token)
            return false
        }
    },
    // 会員登録
    async register (context, data) {
        context.commit('setApiStatus', null)
        const response = await axios.post('/api/register', data)

        if (response.status === CREATED || response.status === OK ) {
            context.commit('setTempRegisterStatus', true)
        }

        context.commit('setApiStatus', false)
        if (response.status === UNPROCESSABLE_ENTITY) {
            context.commit('setRegisterErrorMessages', response.data.errors)
        } else {
            context.commit('error/setCode', response.status, { root: true })
        }
    },

    // ログイン
    async login (context, data) {
        context.commit('setApiStatus', null)
        const response = await axios.post('/api/login', data)

        if (response.status === OK) {
            context.commit('setApiStatus', true)
            context.commit('setUser', response.data)
            context.commit('setToken', response.data.token)
            return false
        }

        context.commit('setApiStatus', false)
        if (response.status === UNPROCESSABLE_ENTITY) {
            context.commit('setLoginErrorMessages', response.data.errors)
        } else {
            context.commit('error/setCode', response.status, { root: true })
        }
    },

    // ログアウト
    async logout (context) {
        context.commit('setApiStatus', null)
        const response = await axios.post('/api/logout')

        if (response.status === OK) {
            context.commit('setApiStatus', true)
            context.commit('setUser', null)
            return false
        }

        context.commit('setApiStatus', false)
        context.commit('error/setCode', response.status, { root: true })
    },

    // ログインユーザーチェック
    async currentUser (context) {
        context.commit('setApiStatus', null)
        // const response = await axios.get('/api/user')

        const response = await axios.post('/api/user', {api_token: this.getters['auth/token']})
        const user = response.data || null

        if (response.status === OK) {
            context.commit('setApiStatus', true)
            context.commit('setUser', user)
            if (user.token) context.commit('setToken', user.token)
            return false
        }

        context.commit('setApiStatus', false)
        context.commit('error/setCode', response.status, { root: true })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
